import axios from 'axios'
const bilgiDogrula = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/bilgiDogrula',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const createCode = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/createCode',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ data.temporyToken
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const verifyCode = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/verifyCode',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ data.temporyToken
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const ogrenciRegister = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/register',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ data.temporyToken
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const ogrenciBilgi = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/bilgi',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const ogrenciListe = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const ogrenciUpdate = async (data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL+'/api/v1/ogrenci/update',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const ogrenciPasswordUpdate = async (data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL+'/api/v1/ogrenci/updatePassword',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};


const ogrenciForgetPassword = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_API_URL + '/api/v1/ogrenci/forgotPassword',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};





export {
    bilgiDogrula,
    createCode,
    verifyCode,
    ogrenciRegister,
    ogrenciBilgi,
    ogrenciUpdate,
    ogrenciListe,
    ogrenciPasswordUpdate,
    ogrenciForgetPassword
};